<!-- Page to verify customer details-->
<!-- Loader -->
<div *ngIf="loading">
  <div class="loading">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</div>
<!-- end of loader -->
<!-- verify role as moderator -->
<div *ngIf="!loading" style="padding: 0% 10%;">
  <ng-container *ngIf="role === 'MODERATOR'">
    <form [formGroup]="bankingDetails">
      <h1 style="font-weight: bold; background-color: rgb(30, 0, 85); color:white; text-align: center;">User's Bank Details</h1>
      <div class="form-row">
        <!-- getting all customer details -->
        <div id="left">
          <label>
            <h2>GST Number</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="gstNumber">
        </div>
      </div>
      <br>
      <div class="form-row">
        <div id="left">
          <label>
            <h2>PAN</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="PAN">
        </div>
      </div>
      <br>
      <div class="form-row">
        <div id="left">
          <label>
            <h2>Currency</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="currency">
        </div>
      </div>
      <br>
      <div class="form-row">
        <div id="left">
          <label>
            <h2>Bank Name</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="bankName">
        </div>
      </div>
      <br>
      <div class="form-row">
        <div id="left">
          <label>
            <h2>Bank Account Number</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="bankAccountNumber">
        </div>
      </div>
      <br>
      <div class="form-row">
        <div id="left">
          <label>
            <h2>IFSC</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="IFSC">
        </div>
      </div>
      <br>
      <div class="form-row">
        <div id="left">
          <label>
            <h2>SWIFT</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="SWIFT">
        </div>
      </div>
      <br>
      <button class="btn" (click)="approve()">APPROVE</button>
      <button id="disapprove" class="btn" (click)="disapprove()">DISAPPROVE</button>

    </form>
  </ng-container>
</div>
<!-- end of customer details -->